<!--设备属性编辑界面-->
<template>
  <!-- <roleBody> -->
  <div class="roleManager">


    <div class="set-left">
      <div class="set-title-top">
        <span class="set-title">角色管理</span>
        <el-button type="primary" size="mini" @click="add_ed">新增</el-button>
      </div>
      <el-scrollbar style="height:92%;width: 100%;">
        <div :class="['item',{'active':item.id == itemActive}]" v-for="(item,index) in roleList" :key="item.roleid"
          @click="chooseRole(item)">
          <div class="name" style="font-size:14px">{{index +1}}.{{item.rolename}}</div>
          <p class="memo" style="font-size:12px;margin-top:10px">备注：{{item.memo}}</p>
          <div class="is-btn">
            <div class="set-caozuo">
              <div @click.stop="edit_ed(item)" class="set-btns" style="margin-right:16px">
                <el-tooltip effect="dark" content="修改" placement="top">
                  <elIconBtn btnType='edit'></elIconBtn>
                </el-tooltip>
              </div>
              <div @click.stop="deleteEntity" class="set-btns">
                <el-tooltip effect="dark" content="删除" placement="top">
                  <elIconBtn btnType='del'></elIconBtn>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>


    <!-- 右边 -->
    <div class="rightBody">
      <div class="areaContainer">
        <div class="save-btn">
          <el-button type="primary" size="mini" @click="saveAuth">保存修改</el-button>
        </div>
        <webRight ref="webRightView"></webRight>
      </div>
      <!-- 加载中 -->
      <div class="el-loading-mask" v-show="loading">
        <div class="el-loading-spinner">
          <svg viewBox="25 25 50 50" class="circular">
            <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
          </svg>
        </div>
      </div>
    </div>
    <!-- 新增修改 -->
    <el-dialog width="20%" v-dialogDrag :title="textMap[dialogStatus]" :close-on-click-modal='false'
      :visible.sync="dialogVisible">
      <div style="display: flex;">
        <el-form :model="temp" ref="temp" :rules="rules" style="width: 80%;height: 120px;padding-top: 10px;">
          <el-form-item label="名称:" prop="rolename">
            <el-input v-model="temp.rolename" style=""></el-input>
          </el-form-item>

          <el-form-item label="备注:" prop="memo">
            <el-input v-model="temp.memo"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">保存</el-button>
      </div>
    </el-dialog>
  </div>
  <!-- </roleBody> -->
</template>

<script type="text/javascript">
  let id = 1000;
  import tab from '@/components/module/tab/tab.vue'
  import roleBody from '@/components/module/slotModule/roleBody.vue'
  import infoList from '@/components/module/universal/infoList.vue'
  import iconButton from '@/components/module/universal/iconButton.vue'
  import nomalInputDialog from '@/components/module/dialog/nomalInputDialog.vue'
  import webRight from '@/page/roleManager/webRight.vue'
  import appRight from '@/page/roleManager/appRight.vue'
  import miniRight from '@/page/roleManager/miniRight.vue'
  //import systemRight from '@/page/roleManager/systemRight.vue'
  import roleManagerStore from '@/page/roleManager/roleManagerStore.js'
  import elIconBtn from '@/components/module/iconBtns.vue'
  export default {
    components: {
      tab,
      roleBody,
      infoList,
      iconButton,
      webRight,
      appRight,
      miniRight,
      elIconBtn
      //systemRight
    },
    props: [],
    data() {
      return {
        loading: false,
        dialogVisible: false,
        dialogStatus: '',
        textMap: {
          add: "新增角色",
          edit: "修改角色"
        },
        //新增修改对象
        temp: {
          'rolename': "",
          'memo': "",
        },
        //星号必填
        rules: {
          rolename: [
            { required: true, message: '请输入名称', trigger: 'blur' }
          ]
        },
        tabPage: 0,
        picked: false,//用户是否有勾选权限标识
        titleList: [{ name: '名称' }, { name: '图形文件' }, { name: '网站页面' }, { name: '描述' }],
        nowProperty: '',
        checkedList: [],//!!!!!勾选的 authList
        roleColumns: [
          {
            name: '名称',
            key: 'rolename'
          }, {
            name: '备注',
            key: 'memo'
          }
        ],
        itemActive: "",
        leftData: []
      }
    },
    created() {
      debugPage = this

    },
    mounted() {
      //预获取一些数据
      // this.doQuery();
    },
    destroyed() { },
    computed: {
      userSelected() {
        return roleManagerStore.state.nowRole
      },
      nowUnit() {
        return this.$store.unitStore.getters.getNowUnit
      },
      roleList() {
        var d = [
          {
            "createTime": 1687760718000,
            "roleid": "0131001935b3478788877ca016f78047",
            "rolename": "配电管理系统",
            "memo": "配电管理系统",
            "id": "0131001935b3478788877ca016f78047",
            "entityName": "PcmRole"
          },
          {
            "createTime": null,
            "roleid": "2bed17d38ae74ba895aac1b9b1b50879",
            "rolename": "能源管理系统",
            "memo": "能源管理相关功能",
            "id": "2bed17d38ae74ba895aac1b9b1b50879",
            "entityName": "PcmRole"
          }

        ];
        return d
      },
      getResourcesByName() {
        return this.$store.resourcesStore.getters.getResourcesByName
      },
      archivesStore() {
        return this.$store.archivesStore
      },
      getEnumByEnumCode() {
        return this.$store.enumStore.getters.getEnumByEnumCode
      },
      getValueTypeText() {
        return this.archivesStore.getters.getValueTypeText
      },
      getAlignText() {
        return this.archivesStore.getters.getAlignText
      },
      entityInfo() {// 加载对应单位的用户列表
        var info = copy(this.nowEntity)
        info.editable = info.editable == 1 ? "是" : "否"
        return [info]
      },
      entityInfoLen() {
        var info = copy(this.nowEntity)
        return [info].length;
      },
    },
    watch: {
      nowProperty: {
        handler(nv, ov) {
        },
        immediate: true,
        deep: true
      },
      leftData(val) {
        if (val.length != 0) {
          this.chooseRole(val[0])
        }
      }

    },
    methods: {
      // 分页切换
      tabPageChange(i) {
        if (this.tabPage == i) {
          return
        }
        if (i == 0) {
          if (this.$refs.appRightView.needSave) {
            this.$dialogMethod.openAgreeDialog("有修改尚未保存", "是否进行保存后再离开", confirm => {
              return
            }, cancel => {
              this.tabPage = i
              this.$refs.appRightView.resetDatas()
            }, true)
          } else {
            this.tabPage = i
            this.$refs.appRightView.resetDatas()
          }
        } else {
          if (this.$refs.webRightView.needSave) {
            // 弹窗确认是否进行保存
            this.$dialogMethod.openAgreeDialog("有修改尚未保存", "是否进行保存后再离开", confirm => {
              return
            }, cancel => {
              this.tabPage = i
              this.$refs.webRightView.coverCheckedIds()
            }, true)
          } else {
            this.tabPage = i
            this.$refs.webRightView.coverCheckedIds()
          }
        }
      },
      getAndSetRightsByRoleId(roleid) {
        this.$api.menuApi.getRightsByRoleIds(roleid,
          respon => {
            this.checkedList = respon;
            //this.$refs.elt.setCheckedKeys(respon)
          }, respon => {
            this.checkedList = []
            this.$dialogMethod.showMessage(respon)
            //this.$refs.elt.setCheckedKeys([])
          })
      },
      chooseRole(item) {
        this.itemActive = item.roleid
        if (!isempty(item)) {
          this.loading = true
          roleManagerStore.commit('setUnit', this.nowUnit)
          if (item == undefined) {
            roleManagerStore.commit('setRole', {})
          } else if (this.userSelected.id == undefined || this.userSelected.id != item.id) {
            roleManagerStore.commit('setRole', item)
          }
          this.getAndSetRightsByRoleId(item.roleid)
          this.nowProperty = item
          this.loading = false
        }
      },
      clean() {
        this.$store.roleStore.commit('cleanRole')
      },
      //刷新
      Refresh_fn() {

      },

      pickItem(state, data) {// data 对象   , state : true  false
        let had = this.checkedList.indexOf(data.id) > -1
        if (state && !had) {
          this.checkedList.push(data.id)
          let list = data.childRights;
          for (let i = 0; i < list.length; i++) {
            this.pickItem(state, list[i])
          }
        } else if (!state && had) {
          let index = this.checkedList.indexOf(data.id)
          this.checkedList.splice(index, 1)
          let list = data.childRights;
          for (let i = 0; i < list.length; i++) {
            this.pickItem(state, list[i])
          }
        }
        this.picked = true;
      },
      saveAuth() {
        this.$refs.webRightView.saveEdit()

      },

      deleteEntity() {
        this.$confirm(`是否删除 ${this.nowProperty.rolename}`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          this.$api.roleApi.deleteRole(this.nowProperty.roleid, respon => {
            this.$message({ showClose: true, message: '删除成功', type: 'success' });
            this.nowProperty = '';
            this.clean()
            // this.doQuery()
          }, respon => {
            respon ? this.$message.error(respon) : this.$message.error('删除失败');
          })

        }).catch(() => {
          // ...
        });
      },


      // 添加弹窗
      add_ed(v, l) {
        this.temp.rolename = ''
        this.temp.memo = ''
        this.dialogStatus = 'add';
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
        // this.temp = { EnergyTypeParentId: v || null};
      },
      // 确认添加
      add_fn(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            console.log(this.temp, 'this.temp');
            console.log(this.roleList, 'this.roleList');
            var flag = false;
            this.roleList.map(v => {
              if (this.temp.rolename === v.rolename) {
                console.log(v.rolename, 'v.rolename');
                console.log(this.temp.rolename, 'v.222');
                flag = true;//有相同名称
                return
              }
            })

            if (flag) {
              this.$message({ showClose: true, message: '名称不能重复！', type: 'info' });
              return
            }
            this.$api.roleApi.saveRole('', this.temp.rolename, this.temp.memo, respon => {
              this.dialogVisible = false;
              this.$message({ showClose: true, message: '添加成功', type: 'success' });
              this.nowProperty = '';
              this.clean()
            }, respon => {
              if (respon) {
                this.$message.error(respon);
              } else {
                this.$message.error('添加失败');
              }
            })
          } else {
            return false;
          }
        });
      },

      // 确认编辑
      edit_fn() {
        this.$refs['temp'].validate(valid => {
          if (valid) {
            var data = this.temp
            this.$api.roleApi.saveRole(this.nowProperty.roleid, data.rolename, data.memo, respon => {
              this.dialogVisible = false;
              this.$message({ showClose: true, message: '修改成功', type: 'success' });
              this.nowProperty = '';
              this.clean()
              // this.doQuery()
            }, respon => {
              this.$dialogMethod.showMessage(respon)
              if (respon) {
                this.$message.error(respon);
              } else {
                this.$message.error('修改失败');
              }
            })

          } else {
            return false;
          }
        });
      },
      //编辑弹窗
      edit_ed(v) {
        console.log("编辑", v);
        this.dialogStatus = 'edit';

        this.temp = Object.assign({}, v);

        this.dialogVisible = true;

        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });

      },
    }
  }
</script>

<style scoped lang="scss">
  /**
 * 这里是默认的一些样式
 */

  html {
    font-size: 625%;
  }

  * {
    margin: 0;
    padding: 0;
    border: 0;
    user-select: none;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  }

  .el-select-dropdown__list {
    width: 100% !important;
    padding-bottom: 20px !important;
  }

  a,
  p,

  label,
  input,
  textarea,
  li,
  u,
  table,
  th,
  td {
    font-size: .14rem;
    font-family: "times new roman";
    line-height: .2rem;
    list-style: none;
  }

  /* button, */
  /* span, */


  @media screen and (max-width: 1366px) {

    p,
    span,
    input,
    textarea,
    table {
      font-size: .12rem;
    }
  }

  .stationData {
    position: absolute;
    bottom: 102%;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    padding: 5px 5px 25px;
    color: #4b4b4b;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    align-items: center;
  }

  .el-tree-node__content {
    height: 36px;
  }

  /* .el-tree-node:focus>.el-tree-node__content {
	background-color:#EAF4FF !important;
} */
  .otherStationsData {
    background: #fff;
    border-radius: 5px;
    padding: 2px 5px;
  }

  .smallRound {
    display: inline-block;
    width: 12px !important;
    height: 12px !important;
    border: 1PX solid #fff;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 100%;
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, .36);
    box-shadow: 0 1px 3px rgba(0, 0, 0, .36);
  }


  /*百度地图自带样式修改*/

  .BMap_cpyCtrl {
    display: none;
  }

  .anchorBL {
    display: none;
  }


  /*地图标题*/

  .BMap_bubble_title {
    color: white;
    font-size: 13px;
    font-weight: bold;
    text-align: left;
    padding-left: 5px;
    padding-top: 5px;
    border-bottom: 1px solid gray;
    background-color: #0066b3;
  }


  /* 消息内容 */

  .BMap_bubble_content {
    background-color: white;
    padding-left: 5px;
    padding-top: 5px;
    padding-bottom: 10px;
    background-color: rgba(0, 0, 0, 0);
    margin-top: 10px;
  }


  /*
视频使用的样式
*/

  container {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
  }

  video:focus,
  video:active {
    outline: none;
  }


  /*小标题样式*/

  .text_introduce_b {
    line-height: 30px;
    padding-left: 4px;
  }

  .text_introduce_p {
    line-height: 20px;
    padding: 0 0 12px 12px;
  }

  .text_introduce {
    width: 100%;
    margin: 0 10px;
  }

  .phone_img {
    width: 400px;
    max-height: 720px;
    margin: 0 10px;
  }

  /* 统一标题 */
  .newtable-title {
    width: 100%;
    height: 46px;
    display: flex;
    justify-content: space-between;
    border-bottom: 2px solid #E6E6E6;
    margin-bottom: 12px;

  }

  .newtable-title .left-t {
    margin-top: 6px;
  }

  .newtable-title .left-t span {
    font-size: 16px;
    color: #1a1a1a;
  }

  /*标题*/

  .title {
    margin-bottom: .2rem;
    font-size: 30px;
    line-height: 1rem;
    text-align: center;
  }

  .location {
    width: 100%;
    display: flex;
    padding-bottom: .5rem;
    justify-content: space-between;
  }

  .appdocbody {
    height: 100%;
  }

  .usePowerUnitBody {
    background: #11173c !important;
  }

  /*电脑图片*/

  .computer {
    padding-left: 10px;
    padding-bottom: 5px;
    width: 500px;
  }


  /*web大图*/

  .big_computer {
    width: 900px;
  }


  /**
 * 渐隐动画样式
 */

  .nomal-fade-enter-active {
    animation: all 0.3s linear forwards;
  }

  .nomal-fade-leave-active {
    transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .nomal-fade-enter,
  .nomal-fade-leave-to {
    opacity: 0;
  }

  .hideBar::-webkit-scrollbar {
    width: 0 !important;
    height: 0 !important;
  }




  /**
 * 动画样式
 */

  .slide-fade-enter-active {
    transition: all .8s ease;
  }

  .slide-fade-leave-active {
    transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-enter,
  .slide-fade-leave-to {
    transform: translateX(-10px);
    opacity: 0;
  }


  /**
 * 通用控件栏样式
 */

  .buttonLine {
    padding-left: 20px;
    width: calc(100% - 20px);
    display: flex;
    align-items: center;
    height: 50px;
    justify-content: flex-start;
    background: #fff;
    border-left: 1px solid #dddddd;
  }

  .custom-scrollbar {
    height: auto;
    overflow-y: auto;
    overflow-x: auto;
  }


  /* To style the document scrollbar, remove `.custom-scrollbar` */

  .custom-scrollbar::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 0;
    height: 0;
    border-radius: 5px;
  }

  .custom-scrollbar::-webkit-scrollbar-track {
    /* 轨道 */
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 6px;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb {
    /* 滑块 */
    border-radius: 6px;
  }

  .custom-scrollbar:hover::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }


  /*
常用flex样式
*/

  .flexBetween {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .flexAround {
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
  }

  .flexStart {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .flexCenter {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .flexCenterColumn {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }


  /**
 * 弹窗样式
 */

  .dialog-center {
    position: fixed;
    z-index: 99;
    width: 400px;
    height: 300px;
    left: 50%;
    top: 50%;
    margin-left: -200px;
    margin-top: -150px;
    background: white;
    border: #000000 solid 1px;
    border-radius: 20px;
  }

  .textems {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }


  /*树隐藏收缩样式*/

  .elTree_hideButton {
    position: relative;
    top: 50%;
    left: 69%;
    z-index: 99999;
  }

  .elTree_hideButton1,
  .elTree_hideButton2 {
    position: absolute;
    display: flex;
  }

  .elTree_hideButton .el-button {
    width: .15rem;
    position: relative;
    left: 60%;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0);
    border: 0;
  }

  .elTree_hideButton1 {
    width: .3rem;
    height: .3rem;
    align-items: center;
    justify-content: flex-end;
    transform-origin: bottom;
    border-top: 20px solid rgba(0, 0, 0, 0);
    border-right: 20px solid rgba(0, 0, 0, 0.2);
    border-bottom: 20px solid rgba(0, 0, 0, 0);
    border-left: 20px solid rgba(0, 0, 0, 0);
  }

  .elTree_hideButton2 {
    width: .3rem;
    height: .3rem;
    align-items: center;
    justify-content: flex-end;
    transform-origin: bottom;

  }

  .elTree_hideButton2 .el-button {
    left: -110%;
  }

  .elTree_body {
    width: 2.26rem;
    height: 94.5%;
  }

  .transition-box {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }


  /*树统一样式*/

  .el_Tree_Body {
    height: 94.8%;
    background-color: white;
    width: 2.26rem;
    border: 1px solid #ded7d7;
  }

  .el_Tree_Body .el-scrollbar .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .el_Tree_Body .el-tree {
    margin-top: 5px;
  }

  .el-tree-node :nth-child(2) {
    padding: 1px;
    overflow: visible;
  }

  /* .el_Tree_Body .el-checkbox__inner {
	border: 1px solid #797a7c;
} */
  .el-tree-node.is-expanded>.el-tree-node__children {
    width: 100%;
  }

  .el-tree .el-tree-node__content .custom-tree-node {
    display: flex;
    align-items: center;
  }

  .el-tree .el-tree-node__content .custom-tree-node span {
    color: #1A1A1A;
  }

  .el-tree .el-tree-node__content .custom-tree-node img {
    margin-right: 1px;
    width: 16px;
    height: 16px;
  }



  /*加载load样式*/


  /*表单样式*/


  /*页面头部表单样式*/



  .page_top_form .el-form {
    display: flex;
    align-items: center;
    padding-top: 10px;
  }

  .page_top_form .el-form .el-form-item:last-child .el-form-item__content {
    margin-left: 20px !important;
  }




  .el-button+.el-button {
    margin-left: 0px !important;
  }

  /* 按钮最后一个 */
  .last-el-button {
    margin-right: 0px !important;
  }

  /* 查询按钮单独样式 */
  .search-btn {
    margin-left: 20px !important;
    padding: 10px 19px;
  }

  .ml-2 {
    margin-left: 20px;
  }

  /* 滚动样式 */
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .el-scrollbar__view {
    width: 100%;
    white-space: nowrap;
    display: inline-block;
  }



  /* element表格样式 */
  .el-table td,
  .el-table th {
    padding: 10px 0;
  }

  /* element表格斑马线 */
  .el-table--striped .el-table__body tr.el-table__row--striped td {
    background-color: #f5f8fa;
  }

  /* 分页功能输入框 */
  .el-pagination .el-input__inner {
    height: 28px !important;
    line-height: 28px !important;

  }

  .el-button {
    border-radius: 2px;
  }

  /* 删除按钮 */
  .el-button--danger {
    background-color: #ED6547;
    border-color: #ED6547;
  }

  /* 列表导航样式 */
  .list-navigation {
    border-left: 1px solid #EBEBEB;
  }

  .list-navigation .list-item {
    padding: 12px 12px 12px 0px;
    cursor: pointer;
  }

  .list-navigation .list-item .name {
    margin-bottom: 5px;
  }

  .list-navigation .list-item .memo {
    font-size: 14px;
  }

  .list-navigation .list-item .item {
    padding-left: 14px;
    color: #666666;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .list-navigation .list-item .item-btn {
    display: none;
  }

  .list-navigation .list-item:hover .item {
    color: #1a1a1a;
  }

  .list-navigation .list-item:hover .item-btn {
    display: block;
  }

  .list-navigation .item-active {
    font-weight: bold;
  }

  .list-navigation .item-active .item-btn {
    display: block;
  }


  /* 输入框统一高度 */
  .el-input__inner {
    height: 36px;
    line-height: 36px;
    border-radius: 2px !important;
  }

  /* 小号输入框 */
  .el-input-mysmall {
    width: 160px !important;
  }

  /* 大号输入框 */
  .el-input-mybig {
    width: 240px !important;
  }

  .el-input__icon {
    line-height: 36px;
  }

  /* 搜索区域输入框 */
  .search-input-btn {
    width: 100%;
    display: flex;
    align-items: center;
    margin: 0.12rem 0px 0.2rem 0px;
    overflow: hidden;
    height: 36px;
  }

  .search-input-btn .my-search-i {
    width: 100%;
    height: 36px;
    display: flex;
    align-items: center;
  }

  .search-input-btn .input-small {
    display: flex;
    align-items: center;
    margin-left: 0.2rem;

  }

  .search-input-btn .input-small .el-input {
    width: 2.4rem;
  }

  .search-input-btn .myinput .el-input {
    width: 1.6rem;
  }

  .search-input-btn .input-small .search-name {
    color: #1a1a1a;
    white-space: nowrap;
  }

  /* 统一弹窗 */
  .unify-dialog .el-dialog__header {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #E6E6E6;

  }

  .unify-dialog .el-dialog__header span {
    color: #67A3ED;
    font-size: 14px;
    font-weight: bold;
  }

  .unify-dialog .el-dialog__header .el-icon-close {
    font-size: 20px !important;
  }

  .unify-dialog .el-dialog__footer {
    margin-top: 20px;
    text-align: right !important;
    border-top: 1px solid #E6E6E6;

  }

  .unify-dialog .el-dialog__footer button {
    padding: 8px 17px;
  }

  .unify-dialog .el-form-item {
    display: flex;
    /* margin-left: 20px; */
    justify-content: center;
  }

  .unify-dialog .el-form-item .el-form-item__content .el-input__inner {
    width: 2.2rem !important;
  }

  .unify-dialog .el-form-item__label {
    white-space: nowrap;
    width: 54px;
  }

  .unify-dialog .el-dialog__body {
    padding: 20px 0px 0px 20px !important;
  }

  .unify-dialog .el-input__inner {
    height: 34px;
    line-height: 34px;
  }

  .unify-dialog .el-input__icon {
    line-height: 34px;
  }


  /* 删除按钮通用 */
  .del-btn-transfer {
    background-color: #ED6547 !important;
    border-color: #ED6547 !important;
  }

  /* 统一搜索条件+查询按钮 */
  .unify-search-input-btn {
    width: 100%;
    height: 36px;
    display: flex;
    justify-content: space-between;
  }

  .unify-search-input-btn .input-small {
    display: flex;
    align-items: center;
  }

  .unify-search-input-btn .switch {
    display: flex;
  }

  .unify-search-input-btn .switch .isshow-btn {
    width: 52px;
    height: 28px;
    border: 1px solid #E6E6E6;
    text-align: center;
    line-height: 28px;
    color: #999999;
    cursor: pointer;
  }

  .unify-search-input-btn .switch .switch-active {
    color: #368ED9;
    border-color: #368ED9;
    background: #DEEFFE;
  }

  .unify-search-input-btn .switch .left-btn {
    border-radius: 2px 0px 0px 2px;
  }

  .unify-search-input-btn .switch .right-btn {
    border-radius: 0px 2px 2px 0px;
  }

  .search-input-btn .input-small {
    margin-left: 0px;
  }

  /* 统一外边距 */
  .mr-20 {
    margin-right: 20px;
  }

  /* 提示信息 */
  .specification-tips {
    display: flex;
    align-items: center;
    height: 32px;
    padding: 0px 12px;
    background-color: #FFFBE6;
    border: 1px solid #E7DA9B;
    border-radius: 2px;

  }

  .specification-tips i {
    margin-right: 4px;
    color: #FF961C;
    font-size: 16px;

  }

  .specification-tips span {
    color: #666666;
  }

  .specification-tips .view-btn {
    margin-left: 40px;
  }


  /* 分隔线 */
  .divider-line {
    width: calc(100% + 40px);
    height: 1px;
    background-color: #E6E6E6;
    position: relative;
    left: -20px;
    bottom: 1px;
  }


  /* 统一标题 */
  .Files-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 2px solid #E6E6E6;
    padding-bottom: 12px;
  }

  .Files-top .ic-left span {
    font-size: 16px;
    color: #1a1a1a;
    white-space: nowrap;
  }

  .Files-top .el-upload--picture-card {
    width: 100%;
    height: 32px;
    line-height: 32px;
    border: 0px;
  }

  .Files-top .btns {
    display: flex;
  }


  /* 账户参数 类似于选项卡 */
  .set-left {
    width: 265px;
    background-color: #fff;
    margin-right: 8px;
    padding: 12px;
    box-sizing: border-box;
  }

  .set-left .set-title-top {
    border-bottom: 2px solid #e6e6e6;
    padding-bottom: 17px;
    margin-bottom: 20px;
  }

  .set-left .set-title-top .set-title {
    margin-left: 8px;
    font-size: 16px;
  }

  .set-left .item {
    padding: 14px;
    /* border-left: 1px solid #e6e6e6; */
    border: 1px solid #E6E6E6;
    color: #666666;
    margin-bottom: 12px;

  }

  .set-left .active {
    background-color: #e5f3ff;
    /* border-left: 2px solid #368ED9; */
    color: #368ED9 !important;
    border-color: #368ED9;
    font-weight: bold;
  }

  .set-left .item:hover {
    color: #1a1a1a;
    /* border-color: #1A1A1A; */
  }

  .set-left .active span {
    margin-left: 2px;
  }


  /* element插件的表格样式 滚动条 */
  /* .el-table__body-wrapper::-webkit-scrollbar {
		width: 8px;
		height: 8px;
	  }
	  .el-table__body-wrapper::-webkit-scrollbar-thumb {
		border-radius: 4px;
		background-color: #dddee0;
	  } */
  /* 如果需要同时修改水平和垂直方向的滚动条，可以使用如下代码：*/
  .el-table__body-wrapper::-webkit-scrollbar-track {
    background-color: #eee;
  }

  .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
    background-color: #c7c9cc;
  }

  .noData {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .noData img {
    margin-top: 20px;
  }

  .noData .text {
    font-size: 14px;
    color: #999;
  }

  /* 光伏系统 */
  .guangfu-tongyi .con {
    width: 100%;
    height: 100%;
    background-color: #fff;
    box-sizing: border-box;
    padding: 12px 20px 20px 20px;
  }

  .roleManager {
    display: flex;

    .set-title-top {
      display: flex;
      justify-content: space-between;
      align-items: center;

      /deep/.el-button {
        margin-right: 0px !important;
        padding: 6px 11px;
      }


    }

    .set-left .item {
      position: relative;
    }

    .is-btn {
      position: absolute;
      top: 50%;
      transform: translateY(-70%);
      right: 10px;
      display: none;
    }

    .set-caozuo {
      display: flex;
    }

    .set-left .item:hover {
      color: #1a1a1a;

      .is-btn {
        display: block;
      }
    }
  }

  .rightBody {
    width: calc(100% - 274px);
    //  flex-grow: 1;
    height: 100%;
    background-color: #fff;
    position: relative;

    .areaContainer {
      position: relative;
    }

    .save-btn {
      position: absolute;
      top: 12px;
      right: 8px;
    }
  }


  .block {
    width: 100%;
  }

  .custom-tree {
    width: 100%;

  }

  /deep/.el-dialog__header {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #E6E6E6;

    span {
      color: #67A3ED;
      font-size: 14px;
      font-weight: bold;
    }

    .el-icon-close {
      font-size: 20px !important;
    }

  }

  /deep/.el-dialog__footer {
    margin-top: 20px;
    text-align: right !important;
    border-top: 1px solid #E6E6E6;

    button {
      padding: 8px 17px;
    }
  }

  .demo-temp {
    display: flex;
    flex-wrap: wrap;
  }

  /deep/.el-form-item {
    display: flex;
    margin-left: 20px;
  }

  /deep/.el-form-item__label {
    white-space: nowrap;
    width: 54px;
  }

  /deep/.el-dialog__body {
    padding: 20px 0px 0px 20px !important;
  }

  .custom-tree-node {
    text-align: center;
    width: calc(100% - 17px);
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    /* padding-right: 8px; */
    /* border-bottom: 1px solid #000000; */
  }

  .custom-tree-node-ex {
    width: 6rem;
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: 14px;
    padding-right: 8px;
  }

  .custom-tree-node-ex span {
    flex: 1;
    border-left: 1px solid #000000
  }

  .btn-group {
    position: fixed;
    bottom: 0.1rem;
    right: 0.5rem;
    display: flex;
    align-content: center;
  }

  .tabsHeader {
    // margin: 10px 5px;
    overflow: hidden;
  }

  .tabBtnsContainer {
    float: left;
    // border: solid 2px #D1D1D1;
    // border-radius: 16px;
  }

  /deep/.infolist-table-body {
    border: 0px !important;
    border-bottom: 1px solid #ddd !important;
  }

  /deep/.tree-head {
    background-color: #f3f8ff !important;
  }

  /deep/.tree-head td {
    color: #1a1a1a !important;
    box-sizing: border-box;
  }

  /deep/.list-body>li {
    border-bottom: 1px solid dashed;
  }

  .tabBtnsContainer>button {
    cursor: pointer;
    // width: 100px;
    height: 30px;
    // border-radius: 15px;
    // background: #FFFFFF;
    // color: #3D7EFF;
    background-color: #fff;
    color: #999999;
    outline: none;
    font-weight: bold;
    font-size: 15px;
    margin-left: 20px;
    margin-top: 16px;
    margin-bottom: 20px;
  }

  .tabBtnsContainer>.tabActive {
    // background: #3D7EFF;
    // color: #FFFFFF;
    color: #529FFF;
    // width: 110px;
    border-bottom: 2px solid #529FFF;

  }

  >>>.tree {
    width: 5rem;
    background-color: #fff;
  }

  .areaTitle {
    font-size: .15rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // line-height: 16px;
    // border-left: solid 4px #3D7EFF;
    // padding-left: 8px;
    // margin: 15px 10px;
    // margin-bottom: 8px;
    padding-top: 13px;
    margin-right: 20px;
    // margin-top: 25px;
    margin-left: 20px;
    color: #999999;
  }
</style>